import axiosService from './axios.service';
import ResponseService from './response.service';

const list = async (_perPage, _page, user_id, _type) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'user_agreements/list',
      isAuthorized: true,
      params: {
        perPage: _perPage || 10,
        page: _page || 1,
        user_id: user_id,
        type: _type,
      },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const UserAgreementService = {
  list,
};

export default UserAgreementService;
